var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import cx from 'classnames';
import Component from '@arco-design/web-react/es/Tag';
import Tooltip from '@arco-design/web-react/es/Tooltip';
import { useConfigContext } from '../config-provider';
var Tag = function (props, ref) {
    var className = props.className, type = props.type, value = props.value, _a = props.showTip, showTip = _a === void 0 ? false : _a;
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-tag";
    if (type === 'card') {
        if (!value || (Array.isArray(value) && !value.length)) {
            console.error('Error: `card` Tag must have a effective `value`');
            return null;
        }
        var showText = showTip
            ? (Array.isArray(value) ? '+' + value.length : value)
            : (Array.isArray(value) ? value.join(' & ') : value);
        var tipText = showTip
            ? (Array.isArray(value) ? value.join(', ') : value)
            : '';
        var newProps = __assign({}, props);
        delete newProps.showTip;
        return (React.createElement(Tooltip, { content: tipText },
            React.createElement(Component, __assign({ ref: ref, className: cx(className, prefixCls, 'card-tag') }, newProps), showText)));
    }
    return React.createElement(Component, __assign({ ref: ref, className: cx(className, prefixCls) }, props));
};
export default React.forwardRef(Tag);
//# sourceMappingURL=index.js.map